var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/well-known-symbol-wrapped.js